import { AxiosError, AxiosResponse } from 'axios';

export const ResponseHandler = (response: AxiosResponse) => {
  return response.data;
};

export const ResponseErrorHandler = (error: AxiosError) => {
  return error;
};
